import { IEvent } from "@Interfaces";
import { useSetQuantity } from "@Modules/eventPage/utils/merchandise";
import { useEventDataOfSelectedEvent } from "@Utils";

const useMerchandise = () => {
    const { event, eventData } = useEventDataOfSelectedEvent();
    const setQuantity = useSetQuantity();
    const {
        paymentInfo: { quantity, numberOfCustomers = 1 },
    }: IEvent.IStore = event;

    const hasVariants = !!eventData.variantsData?.variants_display_data;
    const selectedVariant = eventData?.selectedVariant;
    const totalInventory = selectedVariant
        ? selectedVariant.total_inventory
        : eventData?.total_inventory;
    const purchasedInventory = selectedVariant
        ? selectedVariant.purchased_inventory
        : eventData?.purchased_inventory;
    const price = hasVariants
        ? eventData?.selectedVariant?.price_per_head
        : eventData.updated_price;
    const allowOfferingOverflow = eventData?.allow_overflow;

    const getMaxCountReached = (isIncrement: boolean): boolean => {
        if (selectedVariant && selectedVariant?.allow_overflow) return false;
        if (allowOfferingOverflow) return false;
        return (
            quantity * numberOfCustomers + (isIncrement ? 1 : -1) >
            totalInventory! - purchasedInventory!
        );
    };

    const handleQuantityChange = (isIncrement: boolean) => (): void => {
        if (hasVariants && !selectedVariant) alert("Please select a variant");
        else if (getMaxCountReached(isIncrement))
            // eslint-disable-next-line no-alert
            alert("Maximum available inventory reached");
        else {
            setQuantity(Math.max(1, quantity + (isIncrement ? 1 : -1)));
        }
    };

    const unitText: string =
        eventData?.metadata?.merchandise?.custom_unit_text || "Price per unit";

    return {
        handleQuantityChange,
        getMaxCountReached,
        unitText,
        currency: eventData.currency,
        price,
        quantity,
    };
};

export default useMerchandise;
